<template>
  <div>
    <v-row no-gutters align="center" class="body-2 mb-2 grey--text">
      <v-col cols="2">
        Artikelbezeichnung
      </v-col>
      <v-col cols="3"> </v-col>
      <v-col cols="2" class="text-center">
        Preis
      </v-col>
      <v-col cols="2" class="text-center">
        Anzahl
      </v-col>
      <v-col cols="2" class="text-center">
        Gesamt
      </v-col>
      <v-col cols="1"> </v-col>
    </v-row>
    <v-row v-for="product in $store.state.cart" :key="product.name">
      <HorizontalProduct
        :product="product"
        :quantity="product.quantity"
        btnAction="remove"
      />
    </v-row>
  </div>
</template>

<script>
import HorizontalProduct from "./HorizontalProduct";

export default {
  components: {
    HorizontalProduct
  }
};
</script>
